import { FC } from 'react';
import { ReactComponent as IconPlaceholder } from './img/placeholder.svg';
import { ReactComponent as IconCancel } from '../../assets/img/IconCancel.svg';
import classNames from 'classnames/bind';
import styles from './Avatar.module.scss';

const cx = classNames.bind(styles);

type AvatarProps = {
  avatar: string | null;
  statusActive:
    | 'new'
    | 'active'
    | 'average_active'
    | 'low_active'
    | 'not_work'
    | 'black_list'
    | '';
  marks?: boolean;
  id?: number;
  name?: string;
  surname?: string;
  height?: string;
  width?: string;
  isDeleted?: boolean;
};

export const Avatar: FC<AvatarProps> = ({
  avatar,
  statusActive,
  marks,
  height = '36px',
  width = '36px',
  isDeleted = false,
}) => {
  const classBorder = cx({
    root: true,
    [`status_${statusActive}`]: statusActive,
    avatar_marks: marks,
    root_marks: marks,
    container_marks: marks,
    shedule_marks: marks,
  });

  const showAvatar = Boolean(avatar) && !isDeleted;
  const avatarSizePx = parseFloat(height) || 36;
  const iconSize = Math.round(avatarSizePx * (16 / 36));

  return (
    <div className={styles.container} style={{ height, width }}>
      <div className={classBorder}>
        {showAvatar ? (
          <img className={styles.avatar} src={avatar!} alt='' style={{ height, width }} />
        ) : (
          <IconPlaceholder style={{ height, width }} />
        )}
      </div>
      {isDeleted && (
        <IconCancel
          className={styles.avatarCancel}
          style={{ width: iconSize, height: iconSize }}
        />
      )}
    </div>
  );
};
